document.addEventListener('DOMContentLoaded', function() {
    /** Product Filter **/
    const collectionContainer = document.querySelectorAll('[data-section-type="collection"]');

    collectionContainer.forEach((el, index) => {
        let isLast = collectionContainer.length === index + 1;
        createCollectionSection(el, isLast);
    });

    function createCollectionSection(element, isLast) {
        const settings          = JSON.parse(element.dataset.sectionSettings);
        let currentTags         = settings['currentTags'];
        const currentSortBy     = settings['sortBy'];
        const temporaryTags     = currentTags.slice(); // Deep copy
        const toolbarElement    = element.querySelector('.CollectionToolbar');
        const porductList       = element.querySelector('product-list.product-list');

        function reloadProducts() {
            document.dispatchEvent(new CustomEvent('theme:loading:start'));

            // Rewrite URL
            if (history.replaceState) {
                const { protocol, host } = window.location;
                const basePath = `${protocol}//${host}${settings.collectionUrl}`;
                const tagPath = currentTags.length ? `/${currentTags.join('+')}` : '';
                const newUrl = `${basePath}${tagPath}?sort_by=${currentSortBy}`;

                window.history.pushState({ path: newUrl }, '', newUrl);
            }

            // Fetch new content
            fetch(`${location.pathname}?view=ajax&sort_by=${currentSortBy}`, {
                credentials: 'same-origin',
                method: 'GET',
            })
                .then((response) => response.text())
                .then((content) => {
                    const tempElement = document.createElement('div');
                    tempElement.innerHTML = content;

                    const newSection = tempElement.querySelector('product-list');
                    if (newSection) {
                        porductList.innerHTML = newSection.innerHTML;
                    }

                    document.dispatchEvent(new CustomEvent('theme:loading:end'));

                    // Scroll to top of collection
                    const collectionMain = element.querySelector('.CollectionMain');
                    if (collectionMain) {
                        let elementOffset = collectionMain.getBoundingClientRect().top - parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10);

                        // Assuming Responsive.matchesBreakpoint('lap-and-up') is a utility function. Stub it for now.
                        if (window.matchMedia('screen and (min-width: 1008px)').matches && toolbarElement && toolbarElement.clientHeight === 0) {
                            elementOffset -= 50;
                        }

                        if (elementOffset < 0) {
                            window.scrollBy({ top: elementOffset, behavior: 'smooth' });
                        }
                    }
                });
        }

        function toggleTag(event) {
            const target = event.target;
            const tag = target.dataset.tag;

            if (!tag) return;

            if (target.classList.contains('is-active')) {
                // Remove tag
                const index = temporaryTags.indexOf(tag);
                if (index !== -1) {
                    temporaryTags.splice(index, 1);
                }
            } else {
                // Remove active sibling's tag if it exists
                const collapsible = target.closest('.Collapsible');
                const activeSibling = collapsible?.querySelector('.is-active');

                if (activeSibling) {
                    const siblingTag = activeSibling.dataset.tag;
                    const siblingIndex = temporaryTags.indexOf(siblingTag);
                    if (siblingIndex !== -1) {
                        temporaryTags.splice(siblingIndex, 1);
                    }
                }

                // Add this tag
                temporaryTags.push(tag);
            }

            updateActiveTags();

            // Auto-commit on desktop if filter is in sidebar
            if (settings.filterPosition === 'sidebar' && window.innerWidth >= 1024) {
                commit();
            }
        }

        function removeUncommittedTags() {
            temporaryTags = currentTags.slice();
            updateActiveTags();
        }

        function applyTags() {
            updateActiveTags();
            commit();
        }

        function resetTags() {
            temporaryTags = [];
            applyTags();
        }

        function updateActiveTags() {
            const tagElements = Array.from(document.body.querySelectorAll('.CollectionFilters [data-tag]'));

            tagElements.forEach((item) => {
                const tag = item.dataset.tag;
                const isActive = temporaryTags.includes(tag);

                item.classList.toggle('is-active', isActive);
                item.parentNode?.classList.toggle('is-selected', isActive);
            });
        }

        function commit() {
            const currentSorted = currentTags.slice().sort().join(',');
            const tempSorted = temporaryTags.slice().sort().join(',');

            if (currentSorted !== tempSorted) {
                currentTags = temporaryTags.slice();
                reloadProducts();
            }

            const resetButtons = Array.from(element.querySelectorAll('[data-action="reset-tags"]'));
            resetButtons.forEach((resetButton) => {
                resetButton.style.display = currentTags.length === 0 ? 'none' : 'block';
            });
        }

        function attachListeners() {
            document.body.addEventListener('click', function (event) {
                const action = event.target.closest('[data-action]');

                if (!action) return;

                switch (action.dataset.action) {
                    case 'toggle-tag':
                        toggleTag(event);
                        break;
                    case 'apply-tags':
                        applyTags();
                        break;
                    case 'reset-tags':
                        resetTags();
                        break;
                }
            });

            window.addEventListener('popstate', function (event) {
                if (event.state?.path) {
                    window.location.href = event.state.path;
                }
            });
        }

        if (isLast) attachListeners();
    }

    /** ChannelAdvisor **/
    const wtbModal = document.getElementById('wtb-modal');
    const wtbContainer = document.getElementById('wtb-modal-container');

    if (wtbModal && wtbContainer) {
        document.addEventListener('click', function (e) {
            const clickedTriggerButton = e.target.closest('.button--wtb');
            const clickedInsideModal = wtbModal.contains(e.target);
            const clickedCloseIcon = e.target.closest('.wtb-close') && wtbModal.contains(e.target);

            if (clickedTriggerButton) { // Show modal
                wtbContainer.classList.add('is-visible');
                document.body.classList.add('modal-open');
            } else if (!clickedInsideModal || clickedCloseIcon) { // Hide modal on outside click or close SVG
                wtbContainer.classList.remove('is-visible');
                document.body.classList.remove('modal-open');
            }
        });

        document.addEventListener('keydown', function (e) { // Close modal on Escape key
            if (e.key === 'Escape') {
                wtbContainer.classList.remove('is-visible');
                document.body.classList.remove('modal-open');
            }
        });
    }

    /* Search */
    document.querySelectorAll('a[data-action="toggle-search"]').forEach(searchButton => {
        searchButton.addEventListener('click', function (e) {
            e.preventDefault();
            document.querySelector('header-search').classList.add('is-visible');
            document.body.classList.add('modal-lg-open');
        })
    });

    document.addEventListener('click', function (e) {
        const clickedCloseSearch = e.target.closest('#predictive-search-form dialog-close-button button');
        if (clickedCloseSearch) {
            document.querySelector('header-search').classList.remove('is-visible');
            document.body.classList.remove('modal-lg-open');
        }
    });

    /* BV Reviews style fix */
    // const bvReviews = document.querySelector('div[data-bv-show="reviews"]')
    // if (bvReviews) { // Only run if BV reviews are present
    //     waitForShadowRoot();
    // }

    // try to find the shadow root every 100ms for 5s
    function waitForShadowRoot(maxAttempts = 50, interval = 100) {
        let attempts = 0;
        const timer = setInterval(() => {
            const bvReviews = document.querySelector('div[data-bv-show="reviews"]')
            if (bvReviews?.shadowRoot) {
                clearInterval(timer);
                styleShadowRoot(bvReviews.shadowRoot);
            } else if (++attempts > maxAttempts) {
                clearInterval(timer);
                console.warn('Bazaarvoice reviews shadow root not found in time');
            }
        }, interval);
    }

    function styleShadowRoot(shadowRoot) {
        const style = document.createElement('style');
        style.textContent = `
            @media screen and (min-width: 1024px) and (max-width: 2560px) {
                div:has(> .bv_rating_content1) {
                    display: flex;
                    flex-wrap: wrap;
                }
                div:has(> .bv_rating_content1) .bv_rating_content1, div:has(> .bv_rating_content1) .bv_rating_content2 {
                    flex: 1 1 0%;
                }
                div:has(> .bv_rating_content1) .bv_rating_content3 {
                    flex: auto;
                }
            }
        `;
        shadowRoot.appendChild(style);
    }
});
